import React from 'react';
import PropTypes from 'prop-types';
import Poster from 'components/Poster';
import { Poster as PosterV2, SIMPLIFIED } from 'componentsV2/Poster';
import { simplifiedPosterHoverEnabled } from 'helpers/ConfigHelper';

const CarouselPoster = ({
  breakpoint,
  descriptionLines,
  favoritesManager,
  isHoverStateV2,
  isSeriesDetailAnonymous,
  item,
  itemIndex,
  maxItems,
  noPreview,
  onPosterClick,
  overrideAdditionalPosterStyle,
  overrideTheme,
  processed,
  posterType,
  renderImage,
  scaleFromLeft,
  scaleFromRight,
  segmentPlaylistButtonAction,
  theme,
}) => {
  const key = `${itemIndex} ${item.id}`;
  const carouselItemContainerStyle = overrideTheme
    ? overrideTheme.carouselItemContainer
    : theme.carouselItemContainer;
  const posterProps = {
    ...processed,
    breakpoint,
    descriptionLines,
    favoritesManager,
    isHoverStateV2,
    isSeriesDetailAnonymous,
    item,
    itemIndex,
    maxItems,
    noPreview,
    onPosterClick,
    overrideAdditionalPosterStyle,
    overrideTheme,
    renderImage,
    scaleFromLeft,
    scaleFromRight,
    segmentPlaylistButtonAction,
  };
  let type = posterType;
  if (!type) type = simplifiedPosterHoverEnabled() ? SIMPLIFIED : null;
  return (
    <div key={key} className={carouselItemContainerStyle}>
      {type ? <PosterV2 {...posterProps} type={type} /> : <Poster {...posterProps} />}
    </div>
  );
};

CarouselPoster.defaultProps = {
  breakpoint: null,
  descriptionLines: 5,
  favoritesManager: {},
  isHoverStateV2: false,
  isSeriesDetailAnonymous: false,
  item: {},
  itemIndex: 0,
  maxItems: 0,
  noPreview: false,
  onPosterClick: () => {},
  overrideAdditionalPosterStyle: false,
  overrideTheme: null,
  processed: {},
  renderImage: () => {},
  segmentPlaylistButtonAction: () => {},
  theme: {},
};

CarouselPoster.propTypes = {
  breakpoint: PropTypes.string,
  descriptionLines: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  favoritesManager: PropTypes.shape({}),
  isHoverStateV2: PropTypes.bool,
  isSeriesDetailAnonymous: PropTypes.bool,
  item: PropTypes.shape({}),
  itemIndex: PropTypes.number,
  maxItems: PropTypes.number,
  noPreview: PropTypes.bool,
  onPosterClick: PropTypes.func,
  overrideAdditionalPosterStyle: PropTypes.bool,
  overrideTheme: PropTypes.shape({}),
  posterType: PropTypes.string,
  processed: PropTypes.shape({}),
  renderImage: PropTypes.func,
  scaleFromLeft: PropTypes.bool,
  scaleFromRight: PropTypes.bool,
  segmentPlaylistButtonAction: PropTypes.func,
  theme: PropTypes.shape({}),
};

export default CarouselPoster;
